/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';
import { AdminAlbumsService } from './services/AdminAlbumsService';
import { AdminEmailService } from './services/AdminEmailService';
import { AdminUsersService } from './services/AdminUsersService';
import { AlbumPasswordService } from './services/AlbumPasswordService';
import { AlbumsService } from './services/AlbumsService';
import { AuthService } from './services/AuthService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class FotoClient {
    public readonly adminAlbums: AdminAlbumsService;
    public readonly adminEmail: AdminEmailService;
    public readonly adminUsers: AdminUsersService;
    public readonly albumPassword: AlbumPasswordService;
    public readonly albums: AlbumsService;
    public readonly auth: AuthService;
    public readonly request: BaseHttpRequest;
    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? '',
            VERSION: config?.VERSION ?? '2.0',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });
        this.adminAlbums = new AdminAlbumsService(this.request);
        this.adminEmail = new AdminEmailService(this.request);
        this.adminUsers = new AdminUsersService(this.request);
        this.albumPassword = new AlbumPasswordService(this.request);
        this.albums = new AlbumsService(this.request);
        this.auth = new AuthService(this.request);
    }
}

